import React from 'react';
import { Box, Typography } from '@mui/material';
import { useBranding } from '../../context/BrandingContext';

interface LogoProps {
  variant?: 'full' | 'icon';
  height?: number | string;
  color?: string;
}

/**
 * Componente de Logo reutilizável
 * Exibe a logo da plataforma ou o nome caso não haja imagem configurada
 * @param variant - 'full' para logo completo, 'icon' para ícone pequeno
 * @param height - Altura da imagem (padrão: 40px para full, 32px para icon)
 * @param color - Cor do texto caso não haja logo (padrão: inherit)
 */
const Logo: React.FC<LogoProps> = ({ variant = 'full', height, color }) => {
  const { branding } = useBranding();

  const defaultHeight = variant === 'icon' ? 32 : 40;
  const logoHeight = height || defaultHeight;

  // Se for variante icon e tiver iconUrl configurado, usa o ícone
  if (variant === 'icon' && branding.iconUrl) {
    return (
      <Box
        component="img"
        src={branding.iconUrl}
        alt={branding.platformName}
        sx={{ height: logoHeight, objectFit: 'contain' }}
      />
    );
  }

  // Se tiver logoUrl configurado, usa a logo
  if (branding.logoUrl) {
    return (
      <Box
        component="img"
        src={branding.logoUrl}
        alt={branding.platformName}
        sx={{ height: logoHeight, objectFit: 'contain' }}
      />
    );
  }

  // Fallback: exibe o nome da plataforma como texto
  return (
    <Typography
      variant="h6"
      sx={{
        fontWeight: 'bold',
        color: color || 'inherit',
        fontSize: variant === 'icon' ? '1rem' : '1.25rem',
      }}
    >
      {branding.platformName}
    </Typography>
  );
};

export default Logo;
